exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".containerCol__OptionsStep-module___w2OlZ .containerForm__OptionsStep-module___2JEcE {\n    width: 100%;\n    margin: 20px 0 0;\n}\n  @media (max-width: 375px) {\n    .containerForm__OptionsStep-module___2JEcE {\n        min-width: 260px;\n    }\n  }\n  \n  @media (min-width: 769px) and (max-width: 1595px) {\n    .containerCol__OptionsStep-module___w2OlZ .containerForm__OptionsStep-module___2JEcE {\n      width: auto;\n    }\n  }\n\n ", ""]);

// Exports
exports.locals = {
	"containerCol": "containerCol__OptionsStep-module___w2OlZ",
	"containerForm": "containerForm__OptionsStep-module___2JEcE"
};